import { CaptionStyles, CaptionLineConfig } from '../../types/asset-types';
import { getFontFullPath } from '../../utils/fontUtils';
import { TransitionInEffect } from '../../types/transitions';

const snazzy: Partial<CaptionStyles> = {
  theme_preset: 'snazzy',
  pageStyle: {
    color: '#ffffff',
    background: '#795dd8',
    borderRadius: '16px',
    paddingLeft: '16px',
    paddingRight: '16px'
  },
  wordStyle: undefined,
  letterStyle: undefined,
  font_location: getFontFullPath('Poppins-Bold.ttf'),
  caps: false,
  line_config: CaptionLineConfig.OneLine,
  font_size: 72,
  transitions: {
    pageIn: TransitionInEffect.Fade
  }
};

export default snazzy;
